<template>
  <div>
    <div id="map">
    </div>
    <p>Loading places {{ percentLoaded }} %</p>
  </div>
</template>

<script>

export default {
  props: ['places'],
  data() {
    return {
      map: {},
      percentLoaded: 0
    }
  },
  async mounted() {
    this.initializeMap()
  },
  watch: {
    places () {
      this.initializeMap()
      this.runPlaceService()
    }
  },
  methods: {
    initializeMap() {
      const centerOfEarth = {lat: 0, lng: 0};
      // The map, centered at Uluru
      this.map = new google.maps.Map(
      document.getElementById('map'), {zoom: 1, center: centerOfEarth});
    },
    // start Google place services
    // but throttle request per second because limitation from maps API
    runPlaceService() {
      const self = this
      const throttleLimit = 2
      const repeatTimes = Math.ceil(this.places.length / throttleLimit)
      let currentRepeat = 1
      const getPlaces = setInterval(() => {
        const endIndex = currentRepeat * throttleLimit
        for (let i= (currentRepeat - 1) * throttleLimit; i < endIndex && i < this.places.length; i++) {
          this.percentLoaded = Math.round(((i + 1) / this.places.length) * 100)
          const request = {
            placeId: this.places[i].placeId
          };
          const service = new google.maps.places.PlacesService(this.map);
          service.getDetails(request, (place, status) => {
            if (status == google.maps.places.PlacesServiceStatus.OK) {
              this.createMarker(place, this.places[i].content);
            }
          });
        }
        currentRepeat += 1
      }, 1000)
      setTimeout(() => {
        clearInterval(getPlaces)
      }, repeatTimes * 1000)
    },
    // create marker based on place object retrieve from place API
    // receive count params for occuring case & can be extend for more later
    createMarker(places, content) {
      // create marker object
      const marker = new google.maps.Marker({
        map: this.map,
        title: places.name,
        animation: google.maps.Animation.DROP,
        position: places.geometry.location
      });
      // create info window
      const hoverInfoContent = `<h4>${places.name}</h4>${content.hover}`
      const hoverInfowindow = new google.maps.InfoWindow({
        content: hoverInfoContent
      })

      const clickInfoContent = `<h4>${places.name}</h4>${content.click}`
      const clickInfowindow = new google.maps.InfoWindow({
        content: clickInfoContent
      })
      const self = this
      marker.addListener('click', function() {
        clickInfowindow.open(this.map, marker);
        self.setMarkerBounce(marker);
      });
      marker.addListener('mouseover', () => {
        hoverInfowindow.open(this.map, marker);
      })
      marker.addListener('mouseout', () => {
        hoverInfowindow.close();
      })
    },
    // custom cuantik animation like bounce
    setMarkerBounce(marker) {
      marker.setAnimation(google.maps.Animation.BOUNCE);
      setTimeout(() => {
        marker.setAnimation(null); 
      }, 750);
    }
  }
}
</script>

<style scoped>
#map {
  height: 510px;
  /* width: 1000px; */
  margin: 0 auto;
  background: gray;
}
</style>